import { Box, Button } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import { FreeTrialDialog } from 'components/shared/free-trial-dialog';
import { useState } from 'react';
import ReactPlayer from 'react-player';
import { useSelector } from 'react-redux';
import { GetConfigData } from 'store/config/selectors';
import { GetUrlBuilderData } from 'store/url-builder';
import { getVideoUrl } from 'utils/pathBuilder';
import style from '../social-network/social-network.module.scss';
import { AddVideoDialog } from './add-video-dialog';

export interface VideoUploadProps {
    builderType: string;
    isFree?: boolean | null;
}

export const VideoUpload = ({ builderType, isFree = null }: VideoUploadProps) => {
    const [openDialog, setOpenDialog] = useState(false);
    const [freeTrialDialog, setFreeTrialDialog] = useState(false);
    const builderData = useSelector(GetUrlBuilderData);
    const confData = useSelector(GetConfigData);
    const videoUrl = getVideoUrl(builderData.video, confData);

    const openFreeTrialDialog = () => setFreeTrialDialog(true);
    const handleCloseFreeTrialDialog = () => setFreeTrialDialog(false);

    return (
        <>
            <Box sx={{ position: 'relative', minHeight: '20em', minWidth: '100%' }}>
                {videoUrl && <ReactPlayer url={videoUrl} controls width='100%' />}
                <Button onClick={!isFree ? () => setOpenDialog(true) : openFreeTrialDialog} className={`${style.videoButton} ${style.videoButtonHover}`}>
                    {videoUrl ? <EditIcon /> : <AddIcon />} {videoUrl ? "Change Video" : "Add Video"}
                </Button>
            </Box>
            {openDialog && <AddVideoDialog open={openDialog} onClose={() => setOpenDialog(false)} builderType={builderType} />}
            {freeTrialDialog && <FreeTrialDialog isOpen={freeTrialDialog} onClose={handleCloseFreeTrialDialog} />}
        </>
    );
};
